import { bl_hr_org_chart_hdr_RowClass } from '../../dbschema/bl_hr_org_chart_hdr.model';
import { BaseContainerModel } from '../base-container.model';


export class OrgChartHdrContainerModel extends BaseContainerModel {
    bl_hr_org_chart_hdr: bl_hr_org_chart_hdr_RowClass = new bl_hr_org_chart_hdr_RowClass();
}